/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// FUNCIÓNES GLOBALES ANTES DEL DOM READY

/* Efecto en el Botón Hamburguer */
function toggleNavMobile() {
  jQuery(".sticky-menu.menu-mobile .hamburguer-icon").toggleClass("change");

  jQuery(".menu-mobile__items").toggleClass("active");
  jQuery("body, body .wrap").toggleClass("hiddenOverflow");
}

//back to top
function scrollToTop() {
  verticalOffset = typeof verticalOffset !== "undefined" ? verticalOffset : 0;
  element = jQuery("body");
  offset = element.offset();
  offsetTop = offset.top;
  jQuery("html, body").animate(
    {
      scrollTop: offsetTop
    },
    500,
    "linear"
  );
}

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages

        $("#menu-item-wpml-ls-11-en a span").html("EN");
        $("#menu-item-wpml-ls-11-zh-hans a span").html("中文");

        var $document = $(document),
          $element = $("body .scroll-top-wrapper"),
          className = "show";

        $document.scroll(function() {
          if ($document.scrollTop() >= 50) {
            // user scrolled 50 pixels or more;
            // do stuff
            $element.addClass(className);
          } else {
            $element.removeClass(className);
          }
        });

        $("body .scroll-top-wrapper").on("click", scrollToTop);

        $(".sticky-menu__items > ul li a").click(function(e) {
          e.preventDefault(); //evitar el eventos del enlace normal
          var strAncla = $(this).attr("href"); //id del ancla
          // console.log(strAncla);

          if (strAncla === "#about") {
            $("body,html")
              .stop(true, true)
              .animate(
                {
                  scrollTop: $(strAncla).offset().top
                },
                1000
              );
          } else {
            $("body,html")
              .stop(true, true)
              .animate(
                {
                  scrollTop: $(strAncla).offset().top - 60
                },
                1000
              );
          }
        });

        $("#newsBoxCarousel .page-header__news__carousel-link a").click(
          function(e) {
            e.preventDefault(); //evitar el eventos del enlace normal
            var strAncla = $(this).attr("href"); //id del ancla
            console.log(strAncla);

            $("body,html")
              .stop(true, true)
              .animate(
                {
                  scrollTop: $(strAncla).offset().top - 60
                },
                1000
              );
          }
        );
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        var flagHover = 0;

        /* Resize the Business container preserving proportions when the window size is not standard */
        function resizeBusiness() {
          var $window = jQuery(window).width();
          if ($window < 1920) {
            jQuery(".business")
              .height(($window * 1080) / 1920)
              .css("max-height", ($window * 1080) / 1920 + "px");
          }
        }

        /* Resize when the page loads. */
        resizeBusiness();

        /* Resize whenever the window changes dimensions. */
        $(window).resize(function() {
          resizeBusiness();
        });

        // Business 1 : hover
        $("#business-1 .business__section__content").hover(
          function() {
            $("#business-1, #business-2, #business-3, #business-4").css({
              "background-image": "url(" + bg1 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-in"
            });
          },
          function() {
            $("#business-1").css({
              "background-image": "url(" + bg1 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-2").css({
              "background-image": "url(" + bg2 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-3").css({
              "background-image": "url(" + bg3 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-4").css({
              "background-image": "url(" + bg4 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
          }
        );

        // Business 2 : hover
        $("#business-2 .business__section__content").hover(
          function() {
            $(this).toggleClass("business-active-2");

            $("#business-1, #business-2, #business-3, #business-4").css({
              "background-image": "url(" + bg2 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-in"
            });
          },
          function() {
            $("#business-1").css({
              "background-image": "url(" + bg1 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-2").css({
              "background-image": "url(" + bg2 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-3").css({
              "background-image": "url(" + bg3 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-4").css({
              "background-image": "url(" + bg4 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
          }
        );

        // Business 3 : hover
        $("#business-3 .business__section__content").hover(
          function() {
            $(this).toggleClass("business-active-3");

            $("#business-1, #business-2, #business-3, #business-4").css({
              "background-image": "url(" + bg3 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-in"
            });
          },
          function() {
            $("#business-1").css({
              "background-image": "url(" + bg1 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-2").css({
              "background-image": "url(" + bg2 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-3").css({
              "background-image": "url(" + bg3 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-4").css({
              "background-image": "url(" + bg4 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
          }
        );

        // Business 4 : hover
        $("#business-4 .business__section__content").hover(
          function() {
            $(this).toggleClass("business-active-4");

            $("#business-1, #business-2, #business-3, #business-4").css({
              "background-image": "url(" + bg4 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-in"
            });
          },
          function() {
            $("#business-1").css({
              "background-image": "url(" + bg1 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-2").css({
              "background-image": "url(" + bg2 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-3").css({
              "background-image": "url(" + bg3 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
            $("#business-4").css({
              "background-image": "url(" + bg4 + ")",
              "background-repeat": "no-repeat",
              transition: "background .25s ease-out"
            });
          }
        );

        $("#businessAccordion .card button").on("click", function() {
          var el = $(this).parents(".card-background");
          if (el.hasClass("active")) {
            //esta expandido
            el.removeClass("active");
          } else {
            //no esta expandido
            $(".card-background").removeClass("active");
            el.addClass("active");
          }
        });

        /* Swiper for news section, desktop version */
        var mySwiper = new Swiper(".swiper-container", {
          // Optional parameters
          direction: "horizontal",
          loop: true,
          observer: true,
          observeParents: true,
          simulateTouch: false,
          spaceBetween: 10,
          nextButton: "#button-next",
          prevButton: "#button-prev",

          // Navigation arrows
          navigation: {
            nextEl: ".news #button-next",
            prevEl: ".news #button-prev"
          },

          // Responsive breakpoints
          breakpoints: {
            320: {
              slidesPerGroup: 1,
              slidesPerView: 1
            },
            375: {
              slidesPerGroup: 1,
              slidesPerView: 1
            },
            768: {
              slidesPerGroup: 1,
              slidesPerView: 1,
              spaceBetween: 30
            },
            992: {
              slidesPerGroup: 1,
              slidesPerView: 1,
              spaceBetween: 0
            },
            1024: {
              slidesPerGroup: 3,
              slidesPerView: 3,
              spaceBetween: 45
            },
            1440: {
              nextButton: "#button-next--desktop",
              prevButton: "#button-prev--desktop",
              slidesPerGroup: 3,
              slidesPerView: 3,
              spaceBetween: 45,
              navigation: {
                nextEl: ".news #button-next--desktop",
                prevEl: ".news #button-prev--desktop"
              }
            }
          }
        });

        var teamSwiper = new Swiper(".swiper-container--team", {
          // Optional parameters
          direction: "horizontal",
          loop: true,
          observer: true,
          observeParents: true,
          simulateTouch: false,
          spaceBetween: 0,
          nextButton: "team__button-next",
          prevButton: "team__button-prev",

          // Navigation arrows
          navigation: {
            nextEl: ".teamSwiper-button-next",
            prevEl: ".teamSwiper-button-prev"
          },
          // Responsive breakpoints
          breakpoints: {
            320: {
              slidesPerGroup: 1,
              slidesPerView: 1
            },
            375: {
              slidesPerGroup: 1,
              slidesPerView: 1
            }
          }
        });

        /* Activating menu items when scrolling */
        //navbar
        var screenHeight = screen.height;
        screenHeight /= 2;
        $(".menu-desktop .sticky-menu__items li a").on("click", function(
          event
        ) {
          console.log("Clicked menu");
          $(this)
            .parent()
            .parent()
            .find("a")
            .removeClass("active");
          $(this).addClass("active");
        });
        $(window).on("scroll", function() {
          $(".target-anchor").each(function() {
            if ($(window).scrollTop() >= $(this).offset().top - screenHeight) {
              var id = $(this).attr("id");
              $(".menu-desktop .sticky-menu__items li a").removeClass("active");
              $(
                ".menu-desktop .sticky-menu__items li a[href=#" + id + "]"
              ).addClass("active");
            }
          });
        });
        /* === END === */

        // JavaScript to be fired on the home page, after the init JS
        $(function() {
          $(document).scroll(function() {
            var $nav = $(".fixed-top");
            $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height());
          });
        });
      }
    },
    nueva_pagina: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
